module.exports = __webpack_public_path__ + "img/dev-create.53525fac.png";